<template>
    <v-sheet>
        <v-textarea v-model="code" flat solo auto-grow rows="8" hide-details class="tags-text__textarea" />
        <v-divider />
        <v-row no-gutters class="pa-2">
            <v-col cols="auto">
                <v-btn tile depressed color="error" outlined @click="sync"> 취소하기 </v-btn>
            </v-col>
            <v-spacer />
            <v-col cols="auto">
                <v-btn tile depressed color="primary" outlined @click="emit"> 적용하기 </v-btn>
            </v-col>
        </v-row>
    </v-sheet>
</template>

<script>
import { initCommonMetatag_Code, initCommonMetatag_CodeToTags } from "@/store/metatags";

export default {
    props: {
        value: { type: Array, default: () => [] },
    },
    data: () => ({
        code: null,
    }),
    methods: {
        sync() {
            // 변수를 바꾸지 않은 원래 값(${code})으로 보여 준다
            this.code = initCommonMetatag_Code(this.value);
        },
        emit() {
            this.$emit("input", initCommonMetatag_CodeToTags(this.code));
        },
    },
    watch: {
        value() {
            this.sync();
        },
    },
    mounted() {
        this.sync();
    },
};
</script>

<style lang="scss" scoped>
.tags-text {
    &__textarea ::v-deep textarea {
        font-size: 0.75rem !important;
        line-height: 1.425;
        font-family: monospace, monospace;
        max-height: 480px;
        overflow-y: auto !important;
    }
}
</style>
